/**
 * True on any iOS/iPadOS browser.
 *
 * Every browser on iOS is WebKit underneath — Chrome, Firefox and Edge there are
 * skins over the same engine — so this correctly catches all of them, which is what
 * we want: the constraint being detected is WebKit's, not Safari's.
 *
 * Two detection paths are needed. iPhone and iPod report themselves in the UA, but
 * iPadOS 13+ deliberately masquerades as `Macintosh`, so a modern iPad is only
 * distinguishable from a desktop Mac by its touch points.
 *
 * Deliberately not `useIsMobile`: that is a responsive-breakpoint hook, this is a
 * platform check, and it is called from non-component code (the editor bootstrap and
 * the export pipeline).
 */
export function isIOS(): boolean {
	if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
	const ua = navigator.userAgent || '';
	return /iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
}
